function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#009CA6",
  d: "M212,0h816c117.1,0,212,94.9,212,212v816c0,117.1-94.9,212-212,212H212 c-117.1,0-212-94.9-212-212V212C0,94.9,94.9,0,212,0z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-33)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-545.833 75)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M1124.8,414.1c-3.9-7.3-9.1-13.9-15.3-19.4c-6.7-5.9-14.4-10.5-22.8-13.5 c-8.8-3.4-18.1-5.1-27.5-5.1H720.8v488h111V713.8h227.4c9.4,0,18.7-1.7,27.5-5.1c8.4-3.1,16.2-7.9,22.8-13.9 c6.1-5.6,11.3-12.1,15.3-19.3c3.8-6.8,5.7-14.4,5.7-22.1V436.5C1130.5,428.6,1128.5,420.9,1124.8,414.1z M1020,488.5v118 c0,0.4-0.2,0.8-0.2,1.2c-0.7,7.8-3.4,13.3-8.1,16.5c-3.3,2.2-7.5,3.3-12.7,3.3H831.3V464.3H999c11.5,0,18.3,5.4,20.3,16.1 c0.1,0.8,0.3,1.5,0.4,2.4c0,0.2,0,0.5,0.1,0.8c0.1,1.4,0.3,2.8,0.3,4.3V488.5z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(467 75)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M175.1,714H283V465.2h58.8c14.9,0,22.4,7.2,22.4,21.6V714h102.8V465.2h65.6 c14.9,0,22.3,7.2,22.3,21.6V714h109.6V443.5c0-9.5-1.7-19.4-5.1-27.3c-3.2-7.7-7.7-14.7-13.2-21c-5.3-6-11.7-10.8-19-14.2 c-6.7-3.3-14.1-5-21.6-5.1H481.8c-18.5,0-34.2,6.3-47,19c-12.9,12.6-19.3,29.6-19.3,48.6c0.1-9.1-1.6-18.1-5-26.6 c-3.3-7.7-7.9-14.8-13.6-21c-5.6-6.1-12-11.5-18.9-14.9c-6.6-3.3-13.9-5.1-21.3-5.1H230.9c-1.7,0.1-3.3,0.5-5,0.7 c-5,0.6-9.9,2-14.5,4.1c-6.9,3.4-13.1,8-18.3,13.7c-5.6,6.1-10,13.1-13,20.8c-3.3,8-5,16.5-5,25.1l-0.1,0.2v53h0.1L175.1,714z"
})));

function SvgAppIconProfometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1240 1240",
    style: {
      enableBackground: "new 0 0 1240 1240"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconProfometer);
export default __webpack_public_path__ + "static/media/appIconProfometer.0d2d6780.svg";
export { ForwardRef as ReactComponent };